const NODE_ENV =
  // "production" ||
  process.env?.NODE_ENV;

const URL = {
  development: "http://localhost:6464",
  //   production: "https://api.hisob.org",
  production: "https://api.cdl-prep.kaktus365.uz",
};

export const BASE_URL =
  URL[NODE_ENV] ||
  URL.production;
